/**
 * Badge - Reusable badge component
 *
 * Displays small labels/tags with consistent styling across the application.
 * Supports different variants for different contexts.
 *
 * @param {node} children - Badge content (text, number, icon)
 * @param {string} variant - Badge style: 'success', 'error', 'warning', 'info', 'neutral', 'primary'
 * @param {string} size - Badge size: 'small', 'medium', 'large'
 * @param {string} className - Additional CSS classes
 * @param {object} ...rest - Additional props to pass through
 */
function Badge({
  children,
  variant = 'neutral',
  size = 'medium',
  className = '',
  ...rest
}) {
  const variantClass = `badge-${variant}`;
  const sizeClass = `badge-${size}`;

  return (
    <span className={`badge ${variantClass} ${sizeClass} ${className}`} {...rest}>
      {children}
    </span>
  );
}

export default Badge;
